<template>
	<div class="bg-w px-3 pb-3">
		<a-tabs v-model:activeKey="activeKey" >
			<a-tab-pane key="1" :tab="$t('common.teacherIntroduction')" >
				<div class="flex alcenter ">
					<div style="width: 70%;">
						<teacher-details :showPart="'1'" :teacher_id="Number(teacherInfo.id)"></teacher-details>
					</div>
					<div>
						<appointment-window :buyForModal="true" :teacher_id="Number(teacherInfo.id)"></appointment-window>
					</div>
				</div>
				
				
			</a-tab-pane>
			<a-tab-pane key="2" :tab="$t('becomeTeacher.teachingArchives')" >
				<div class="becomeTeacher-wid">
					{{ $t('becomeTeacher.startCreateProfile2') }}
				</div>
				<div class="">
					<span class="cl-red">*</span>{{$t('becomeTeacher.Required')}}
				</div>
				<div class="flex mt-3" style="width: 100%;">
					<div class="cl-black" style="width: 50%;padding-right: 10px;">
						{{ $t('becomeTeacher.speakLanguages') }}<span class="cl-red">*</span>
					</div>
					<div class="cl-black" style="width: 50%;padding-left: 10px;">
						{{ $t('becomeTeacher.level') }}
					</div>
				</div>
				
				<div class="flex mt-2" style="width: 100%;">
					<div class="" style="width: 50%;padding-right: 10px;">
						<select class="form-select ft16 mt-2" v-model="language_id" @change="changeLanguage">
							<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
							<option :value="item.id" v-for="(item,index) in languageList ">{{item.name}}</option>
						</select>
					</div>
					<div class="" style="width: 50%;padding-left: 10px;">
						<select class="form-select ft16 mt-2" v-model="language_level_id"  @change="changeLevel">
							<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
							<option :value="item.id" v-for="(item,index) in languageLevelList ">{{item.name}}</option>
						</select>
					</div>
				</div>
				<div class="mt-2 flex" v-if="form.teacher_language.length>0">
					<div v-for="(item,index) in form.teacher_language" class="pos-re border-gray mr10">
						<div class="ml10 p-2 bg-w ft14" >
							{{item.language_name}} {{item.language_level_name}}
						</div>
						<div class="pos-ab" style="top: -13px;right: -5px;" @click="form.teacher_language.splice(index,1)">
							<a-icon type="close-circle" ></a-icon>
						</div>
						
					</div>
				</div>
				
				<div class="flex mt-3">
					<div style="width: 50%;padding-right: 10px;">
						<div class="cl-black">
							{{ $t('becomeTeacher.professorLevel') }}<span class="cl-red">*</span>
						</div>
						<a-select size="large" style="width: 100%;" mode="multiple" :placeholder="$t('common.select')" 
						class="mt-2" v-model="form.professor_level_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in professorLevelList">
								{{item.name}}
							</a-select-option>
						</a-select>
					</div>
					
				</div>
				<div class="flex mt-3">
					<div style="width: 50%;padding-right: 10px;">
						<div class="cl-black">
							{{ $t('becomeTeacher.teachingSubjects') }}<span class="cl-red">*</span>
						</div>
						
						<a-select size="large" style="width: 100%;" mode="multiple" :placeholder="$t('common.select')"
						class="mt-2" v-model="form.course_classify_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in classifyList">
								{{item.name}}
							</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="cl-black mt-3">
					{{ $t('becomeTeacher.specialEducationExperience') }}
				</div>
				<a-select
				      v-model:value="form.special_educational_experience_id"
				      mode="multiple"
				      :placeholder="$t('becomeTeacher.pleaseFill')"
				      style="width: 100%"
					  showArrow
					  class="mainIndex-class-select mt-2"
					  size="large"
					  :options="specialEducationalExperienceL"
				    >
				</a-select>
				<div class="flex mt-3">
					<div style="width: 50%;padding-right: 10px;">
						<div class="cl-black">
							{{ $t('teacherVue.highestEducationLevel') }}<span class="cl-red">*</span>
						</div>
						<select class="form-select ft16 mt-2" @change="" v-model="form.education_background_id">
							<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
							<option :value="item.id" v-for="item in educationBackgroundL">{{item.name}}</option>
						</select>
					</div>
				</div>
				<div class="mt-3 flex justify-content-between">
					<button type="button" class="btn btn-theme" @click="teacherUpdate">{{ $t('userMySetting.save') }}</button>
				</div>
			</a-tab-pane>
			<a-tab-pane key="3" :tab="$t('common.personalPhoto')" >
				<div class="" style="width: 700px;">
					<div class="text-center ftw600 cl-black ftr-1-25">
						{{$t('common.personalPhoto')}}
					</div>
					<div class="mt-3">
						{{$t('common.phontHint')}}
					</div>
					<div class="flex mt-3">
						<div style="width: 150px;">
							<upload-img v-model="form.photo_image"></upload-img>
						</div>
						<div>
							<div class="ftw600">{{$t('becomeTeacher.listFour2')}}</div>
							<li>{{$t('becomeTeacher.listFour3')}}</li>
							<li>{{$t('becomeTeacher.listFour4')}}</li>
						</div>
					</div>
					<hr />
					<div class="flex ">
						<div>
							<div class="ftr-1-25 ftw600 cl-black text-center">
								{{$t('common.photoDemonstration')}}
							</div>
							<div class="mt-3 flex">
								<img src="https://qiniu.boyanhy.com/9033e794e8e1816c8577824264185d751689578379.jpg-ss.png" alt="" 
								class="teachingArchives-photo" />
								<img src="https://qiniu.boyanhy.com/9033e794e8e1816c8577824264185d751689578379.jpg-ss.png" alt="" 
								class="teachingArchives-photo"/>
								<img src="https://qiniu.boyanhy.com/9033e794e8e1816c8577824264185d751689578379.jpg-ss.png" alt="" 
								class="teachingArchives-photo"/>
							</div>
						</div>
						<div>
							<div>
								{{$t('common.personalPhoto1')}}
							</div>
							<ul>
								<li>{{$t('common.personalPhoto2')}}</li>
								<li>{{$t('common.personalPhoto3')}}</li>
								<li>{{$t('common.personalPhoto4')}}</li>
								<li>{{$t('common.personalPhoto5')}}</li>
								<li>{{$t('common.personalPhoto6')}}</li>
								<li>{{$t('common.personalPhoto7')}}</li>
								<li>{{$t('common.personalPhoto8')}}</li>
							</ul>
							
						</div>
					</div>
					<hr />
					<a-checkbox >{{$t('common.personalPhoto9')}}</a-checkbox>
					<div class="mt-3 flex justify-content-between">
						<button type="button" class="btn btn-theme" @click="teacherUpdate">{{ $t('userMySetting.save') }}</button>
					</div>
				</div>
			</a-tab-pane>
			<a-tab-pane key="4" :tab="$t('teacherSet.educationBackground')" >
				<div class="cl-black flex column alcenter" style="width: 100%;" v-if="form.educational_qualifications_information">
					<div class=" text-center">
						學歷
					</div>
					<div class="text-center">
						請填寫以下學歷資料，而有關資料會在老師的個人簡介展示(證書副本除外)
					</div>
					<div class="wid-100" v-for="(item,index) in form.educational_qualifications_information">
						<div class="flex alcenter mt-4" style="width: 100%;">
							<div style="width: 30%;" class="text-center" v-if="item.yearRange!=[]">
								<div>
									{{$t('becomeTeacher.yearRange')}}
								</div>
								<div class="mt-3"> {{item.yearRange[0]}} - {{item.yearRange[1]}} </div>
							</div>
							<div class="ml10 text-center" style="width: 30%;">
								<div>
									{{$t('becomeTeacher.educationBackground1')}}
								</div>
								<div class="mt-3">
									{{item.schoolName}}
								</div>
							</div>
							<div class="ml10 text-center" style="width: 30%;">
								<div>
									{{$t('becomeTeacher.educationBackground2')}}
								</div>
								<div class="mt-3">
									{{item.diplomaName}}
									
									<span class="cl-theme ml10">老師提供，已存儲</span>
								</div>
								
								
							</div>
						</div>
					</div>
					<div class="border-b wid-100 mt-3" >
						
					</div>
					<div class="text-center mt-3">
						{{$t('becomeTeacher.educationBackground6')}}
					</div>
					<div class="text-center mt-3">
						{{$t('becomeTeacher.educationBackground7')}}
					</div>
					<div class="text-center mt-2"  style="width: 70%;">
						{{$t('becomeTeacher.educationBackground8')}}
					</div>
					<div class="mt-3 border-gray px-3 py-1" v-if="form.professional_teacher_qualification.registeredTeacher==1">
						{{$t('becomeTeacher.educationBackground9')}}
					</div>
					<div class="flex alcenter mt-4" style="width: 100%;">
						<div style="width: 30%;" class="text-center" v-if="form.professional_teacher_qualification.year">
							<div>
								{{$t('becomeTeacher.yearRange')}}
							</div>
							<div class="mt-3"> {{form.professional_teacher_qualification.year}} </div>
						</div>
						<div class="ml10 text-center" style="width: 30%;">
							<div>
								{{$t('becomeTeacher.educationBackground11')}}
							</div>
							<div class="mt-3">
								{{form.professional_teacher_qualification.institutionName}}
							</div>
						</div>
						<div class="ml10 text-center" style="width: 30%;">
							<div>
								{{$t('becomeTeacher.educationBackground12')}}
							</div>
							<div class="mt-3">
								{{form.professional_teacher_qualification.certificateName}}
								
								<span class="cl-theme ml10">老師提供，已存儲</span>
							</div>
						</div>
					</div>
					<div class="border-b wid-100 mt-3" >
						
					</div>
					<div class="text-center mt-3">
						{{$t('becomeTeacher.educationBackground14')}}
					</div>
					<div class="flex alcenter mt-4" style="width: 100%;">
						<div style="width: 30%;" class="text-center" v-if="form.other_professional_qualifications.year">
							<div>
								{{$t('becomeTeacher.yearRange')}}
							</div>
							<div class="mt-3"> {{form.other_professional_qualifications.year}} </div>
						</div>
						<div class="ml10 text-center" style="width: 30%;">
							<div>
								{{$t('becomeTeacher.educationBackground11')}}
							</div>
							<div class="mt-3">
								{{form.professional_teacher_qualification.institutionName}}
							</div>
						</div>
						<div class="ml10 text-center" style="width: 30%;">
							<div>
								{{$t('becomeTeacher.educationBackground12')}}
							</div>
							<div class="mt-3">
								{{form.professional_teacher_qualification.certificateName}}
								
								<span class="cl-theme ml10">老師提供，已存儲</span>
							</div>
						</div>
					</div>
					<div class="border-b wid-100 mt-3" >
						
					</div>
					<div class="text-center mt-3">
						{{$t('becomeTeacher.educationBackground16')}}
					</div>
					<div class="wid-100" v-for="(item,index) in form.public_examination_results">
						<div class="flex alcenter mt-4" style="width: 100%;">
							<div style="width: 30%;" class="text-center" v-if="item.year">
								<div class=""> {{item.year}} </div>
							</div>
							<div class="ml10 text-center" style="width: 30%;">
								<div class="">
									{{item.exam}}
								</div>
							</div>
							<div class="ml10 text-center" style="width: 30%;">
								
								<div class="">
									{{item.grade}}
									<span class="cl-theme ml10">老師提供，已存儲</span>
								</div>
								
								
							</div>
						</div>
					</div>
				</div>
			</a-tab-pane>
			<a-tab-pane key="5" :tab="$t('becomeTeacher.workExperience')" >
				<div v-for="(item,index) in form.work_experience">
					<div class="flex mt-4" v-if="item.is_edit" style="width: 100%;" >
						<div>
								<div class="flex alcenter" >
								<div>
									<div>
										{{$t('becomeTeacher.yearRange')}}
									</div>
									<a-range-picker valueFormat="YYYY-MM-DD" style="width: 200px;" class="mt-2"
									 v-model="item.yearRange"/>
								</div>
								<div class="ml10">
									<div>
										{{$t('becomeTeacher.workingBody')}}
									</div>
									<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
									 v-modal="item.schoolName"/>
								</div>
								<div class="ml10">
									<div>
										{{$t('becomeTeacher.position')}}
									</div>
									<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
									 v-model="item.diplomaName" />
								</div>
							</div>
							<div class="mt-3 ftw600 ftr-1-25">
								{{$t('becomeTeacher.listFour1')}}
							</div>
							<div class="flex mt-3">
								<div style="width: 150px;">
									<upload-img v-model="item.photo"></upload-img>
								</div>
								<div>
									<div class="ftw600">{{$t('becomeTeacher.listFour2')}}</div>
									<li>{{$t('becomeTeacher.listFour3')}}</li>
									<li>{{$t('becomeTeacher.listFour4')}}</li>
								</div>
							</div>
						</div>
						
						
					</div>
					<div class="flex alcenter mt-4" style="width: 100%;" v-else>
						<div style="width: 200px;" class="" v-if="item.yearRange!=[]">
							<div>
								{{$t('becomeTeacher.yearRange')}}
							</div>
							<div class="mt-3"> {{item.yearRange[0]}} - {{item.yearRange[1]}} </div>
						</div>
						<div class="ml10" style="width: 200px;">
							<div>
								{{$t('becomeTeacher.workingBody')}}
							</div>
							<div class="mt-3">
								{{item.schoolName||'暫無'}}
							</div>
						</div>
						<div class="ml10 " style="width: 200px;">
							<div>
								{{$t('becomeTeacher.position')}}
							</div>
							<div class="mt-3">
								{{item.diplomaName||'暫無'}}
								
								<span class="cl-theme ml10">老師提供，已存儲</span>
							</div>
							
							
						</div>
					</div>
				</div>
				<div class="ftw600 cl-theme mt-3 clickAct" @click="addWE">
					{{$t('becomeTeacher.listFour5')}}
				</div>
				<div class="mt-3 flex justify-content-between">
					<button type="button" class="btn btn-theme" @click="teacherUpdate">{{ $t('userMySetting.save') }}</button>
				</div>
			</a-tab-pane>
			<a-tab-pane key="6" :tab="$t('becomeTeacher.fillIntroduction')" >
				<div class="cl-black mt-5">
					{{ $t('becomeTeacher.listFive1') }}
				</div>
				<div class="cl-black mt-3">
					{{ $t('becomeTeacher.listFive2') }}
				</div>
				<a-input v-model:value="form.synopsis" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
				<div class="cl-black mt-3">
					{{ $t('becomeTeacher.listFive3') }}
				</div>
				<div class="cl-black mt-3 ftr-1-25">
					{{ $t('becomeTeacher.listFive4') }}
				</div>
				<div class="cl-info mt-3">
					{{ $t('becomeTeacher.selfIntroduction') }}
				</div>
				<div class="mt-2">
					<quill-editor ref="myQuillEditor" v-model="content" :options="editorOption"
					 @change="onEditorChange($event)"/>
				</div>
				<div class="cl-black mt-3">
					{{ $t('becomeTeacher.listFive5') }}
				</div>
				<div class="mt-3 flex justify-content-between">
					<button type="button" class="btn btn-theme" @click="teacherUpdate">{{ $t('userMySetting.save') }}</button>
				</div>
			</a-tab-pane>
			<a-tab-pane key="7" :tab="$t('common.introductionFilm')" >
					<div class="cl-black ">
						錄製你的個人簡介視頻，並將連結貼在下面
					</div>
					<div class="mt-2">
						上傳影片
					</div>
					<div class="flex mt-2">
						<a-input v-model:value="videoPath" :placeholder="$t('becomeTeacher.inputYoutubeLink')" class="ft16"
							style="height: 40px;" />
						<button type="button" class="btn btn-theme ml10" style="width: 80px;height: 40px;" @click="setVideo">{{ $t('becomeTeacher.confirm') }}</button>
					</div>
					<div class="flex mt-3">
						<div v-for="(item, index) in form.video_files" :key="index" class="video-item pos-re">
							<video :src="item" class=" mr10" controls style="width: 120px;height: 120px;"></video>
							<a-icon type="close" size="20" class="pos-ab" style="right: 10px; top: -4px;" @click="delVideo(index)"></a-icon>
						</div>
					</div>
					<div class="border-b wid-100 mt-3" >
						
					</div>
					<div class="flex alcenter space mt-3">
						<div>
							<div>你的影片必需符合以下要求:</div>
							<ul>
								<li>片長約1-2分鐘</li>
								<li>以橫屏拍攝，最佳比例為16:9</li>
								<li>燈光和背景需柔和自然</li>
								<li>片長約不能明示或暗示任何與本平台無關的商標、聯絡或連結分鐘</li>
								<li>不能遮擋臉部和眼睛(除特別需要)</li>
								<li>不能侵犯他人著作、版權和隱私權</li>
								<li>不可透露自己全名</li>
								<li>嚴禁含有不雅、粗言穢語、政治言論、任何宣傳、詆毀誹謗等類似成份</li>
							</ul>
						</div>
						<div>
							<div>影片內容:</div>
							<ul>
								<li>先親切打招呼和以暱稱介紹自己</li>
								<li>簡介自己專業資格、履歷和教學經驗</li>
								<li>介紹考試心得和提分技巧和策略</li>
								<li>鼓勵學生試堂</li>
							</ul>
							<div class="mt-3">影片上載指南:</div>
							<ul>
								<li>請將影片上載至Youtube一個獨立的帳號，而頻道中不能有其他與本平台無關的影片，及不能留下任何聯絡</li>
								<li>最多上載4條，第一條為封面片段、履歷和教學經驗</li>
							</ul>
						</div>
					</div>
					<a-checkbox v-model="chackRadio2">本人清楚及明白上述影片要求，並同意影片將展示在本平台上。</a-checkbox>
					<div class="mt-3 flex justify-content-between">
						<button type="button" class="btn btn-theme" @click="teacherUpdate(2)">{{ $t('userMySetting.save') }}</button>
					</div>
			</a-tab-pane>
			<a-tab-pane key="8" :tab="$t('common.teachingAchievements')" >
				<div class="cl-black" style="width: 70%;">
					上存你的教學成果，例如：你的過往的教學獎項、學生成績單、獎狀、家長的嘉許對話截圖等等。(注意：必需遮蓋所有敏感個人資料，而上載前必需獲得資料的相關人士同意。)
				</div>
				<div class="mt-2">
					<upload-img-list v-model="form.introduce_images"></upload-img-list>
				</div>
				
				<div class="border-b wid-100 mt-3" >
					
				</div>
				<div class="flex alcenter space mt-3">
					<div>
						<div>你的圖片必需符合以下要求:</div>
						<ul>
							<li>圖片要清晰，如果是證書和成績單，建議用掃描器存取影像</li>
							<li>圖片不能帶有除你以外其他人的樣貌(包括學生和家長)</li>
							<li>圖片不能載有任可人的個人資料和私隱</li>
							<li>必需遮蓋名字、出生日期、學生/考生編號、班別、學號、證書編號等敏感資料</li>
							<li>不能侵犯他人著作、版權和隱私權</li>
							<li>不可透露自己全名</li>
							<li>嚴禁含有不雅、粗言穢語、政治言論、任何宣傳、詆毀誹謗等類似成份</li>
							<li>不能明示或暗示任何與本平台無關的商標、聯絡或連結</li>
						</ul>
					</div>
					<div>
						<div>圖片內容建議::</div>
						<ul>
							<li>學生的成績單、獎項、學校取錄信、派位結果</li>
							<li>你過往的獎項(教學和學歷)、公開試成績單、畢業證書、專業資格等等</li>
							<li>你的筆記、作業或試題樣本</li>
							<li>學生/家長對你的嘉許截圖</li>
						</ul>
					</div>
				</div>
				<a-checkbox v-model="chackRadio1" >本人清楚及明白上述圖片要求，並於上載前已獲得資料的相關人士同意。</a-checkbox>
				<div class="mt-3 flex justify-content-between">
					<button type="button" class="btn btn-theme" @click="teacherUpdate(1)">{{ $t('userMySetting.save') }}</button>
				</div>
			</a-tab-pane>
			<a-tab-pane key="9" :tab="$t('common.startTeaching')" >
				<div>
					請完成以下設置，便可申請開教：
				</div>
				<div class="cl-black">
					<div class="flex p-2 border-b">
						<div style="width: 200px;">設置</div>
						<div style="width: 200px;">狀態</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('becomeTeacher.fillPersonalInfo')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" v-if=" !buttonInfo.is_personal_profile" @click="toComplete(8)">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('teacherSet.paymentMethod')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" v-if="!buttonInfo.is_pay" @click="toComplete(8)">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('teacherSet.contactTools')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" v-if="!buttonInfo.is_video_tool" @click="toComplete(8)">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('teacherIndex.schedule')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" @click="toComplete(5)"  v-if="!buttonInfo.is_schedule">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('teacherIndex.classManagement')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" @click="toComplete(4)" v-if="!buttonInfo.is_class_manage">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('becomeTeacher.teachingArchives')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" @click="activeKey = '2'" v-if="!buttonInfo.is_teaching_portfolio">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('common.personalPhoto')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" @click="activeKey = '3'" v-if="!buttonInfo.is_personal_photo">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('becomeTeacher.workExperience')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme"  @click="activeKey = '5'" v-if="!buttonInfo.is_work_experience">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('becomeTeacher.fillIntroduction')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" @click="activeKey = '6'" v-if="!buttonInfo.is_self_introduction">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2">
						<div style="width: 200px;">{{$t('common.introductionFilm')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" @click="activeKey = '7'" v-if="!buttonInfo.is_introduction_film">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2 border-b">
						<div style="width: 200px;">{{$t('common.teachingAchievements')}}</div>
						<div style="width: 200px;">
							<button class="btn btn-theme" @click="activeKey = '8'" v-if="!buttonInfo.is_teaching_achievements">{{$t('common.toComplete')}}</button>
							<button class="btn btn-outline-theme" v-else>{{$t('common.teacherCompleted')}}</button>
						</div>
					</div>
					<div class="flex alcenter p-2 ft24" >
						<div style="width: 200px;"></div>
						<div style="width: 200px;"  v-if="button_unfinished!=0">
							(<span class="cl-red">
								{{button_unfinished}}
							</span>/11)
						</div>
						<button class="btn btn-outline-gray" @click="data_completed=='false'? teacherUpdate():'' " :disabled="(button_unfinished!=0||data_completed!=='false')?true:false">
							{{data_completed =='false'?'申請開始教學': '教學中'}}
						</button>
					</div>
				</div>
			</a-tab-pane>
		</a-tabs>
	</div>
</template>

<script>
	import teacherDetails from "../../../components/teacher/teacherDetails.vue"
	import appointmentWindow from "../../../components/appointmentWindow.vue"
	import uploadImg from "../../../components/upload/upload.vue"
	import uploadImgList from '../../../components/upload/list.vue'
	export default {
		components:{
			teacherDetails,
			appointmentWindow,
			uploadImg,
			uploadImgList
		},
		props:{
			data_completed_info:{
				type:Object,
				default:{}
			},
			defaultActiveKey:{
				type:String,
				default:'1'
			}
		},
		data() {
			return{
				activeKey:'1',
				form: {
					language_id: 0,
					language_level_id: 0, //语言等级ID
					professor_level_id: undefined, //教授级别ID
					special_educational_experience_id: [], //特殊教育经验ID
					education_background_id: 0, //学历ID
					name: '', //老师名称
					surname:'',//姓氏
					photo_image: '', //老师照片
					certificate_image: [], //证书图片
					synopsis: '', //简介
					self_introduction_content: '', //自我介绍
					introduce_images:[],//图片介绍
					video_files:[],//视频介绍
					experience_price:[],//体验课价格
					teacher_language:[],
					nationality:null,//国籍
					place_abode:'',//居住地
					mobile:'',//手机号码
					email:'',//电子邮箱
					recommend_email:'',//推荐老师邮箱
					course_classify_id:undefined,
					en_name:'',
					en_surname:'',
					educational_qualifications_information:[
						{
							yearRange:['',''],
							schoolName:'',
							diplomaName:'',
							photo:''
						}
					],
					professional_teacher_qualification:{
						registeredTeacher:0,
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					},
					other_professional_qualifications:{
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					},
					public_examination_results:[{
						year:'',
						exam:'',
						subject:'',
						grade:'',
						photo:''
						
					}],
					work_experience:[{
						yearRange:['',''],
						schoolName:'',
						diplomaName:'',
						photo:''
					}]
				},
				language_id:0,
				language_level_id:0,
				aotuForm: {
					coach_id: 0,
					private_scheduling_duration: '30', //课程时长
					private_scheduling_interval: '30', //时间间隔
					show_store_data: [{
						rengeTime: [],
						start_s: '',
						end_s: '',
						day_index: [1, 2, 3, 4, 5, 6, 7]
					}],
					store_data: []
				},
				weekList: [{
						value: 1,
						title: '周一'
					},
					{
						value: 2,
						title: '周二'
					},
					{
						value: 3,
						title: '周三'
					},
					{
						value: 4,
						title: '周四'
					},
					{
						value: 5,
						title: '周五'
					},
					{
						value: 6,
						title: '周六'
					},
					{
						value: 7,
						title: '周日'
					}
				],
				showTimeList: [],
				selectWeek: 1,
				weekCountList: [], //用来数据展示计算的数组，以周为基础
				deadlineDate: '',
				divideIntoVisible: false,
				classVisible: false,
				languageList: [], //语言列表
				selectLanguageList: [],
				languageLevelList: [], //级别
				professorLevelList: [], //教授级别
				specialEducationalExperienceL: [], //特殊教育经历
				educationBackgroundL: [], //学历
				
				content: '',
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['blockquote', 'code-block'],
							[{ 'header': 1 }, { 'header': 2 }],
							[{ 'list': 'ordered'}, { 'list': 'bullet' }],
							[{ 'script': 'sub'}, { 'script': 'super' }],
							['clean'],
							['link', 'image'] // 添加图片按钮
						],
						imageUploader: {
							upload: (file) => {
								return new Promise((resolve, reject) => {
									// 替换为你的实际上传接口
									this.$http.upload(file)
										.then(response => {
											// 假设接口返回图片的 URL
											resolve(response.fullurl); 
										})
										.catch(error => {
											reject(error);
										});
								});
							}
						}
					},
					theme: 'snow',
					placeholder: '请输入内容...',
					readOnly: false
				},
				videoPath:'',
				currency:localStorage.getItem('currency'),
				classifyList:[],//课程分类
				courseClassifyId:0,//课程分类ID
				courseList:[],
				courseInfo:{
					course_id:0,
					teacherCourse:[]
				},
				effective_type_data:1,
				teacher_time:[],
				formTeacherC:[],//老师的课程信息
				formTeacherItem:{},//展示老师课程信息
				formTeacherTypeId:0,
				classMoney:0,//一堂课的钱
				teacherClassMoney:0,//老师一堂课所得
				classList:[
					{
						num:5,
						discount:'',
						pl_discount:'0-9%',
						money:'',
						showMoney:'',
						selected:false,
						max:'9'
					},
					{
						num:10,
						discount:'',
						pl_discount:'0-19%',
						money:'',
						showMoney:'',
						selected:false,
						max:'19'
					},
					{
						num:20,
						discount:'',
						pl_discount:'0-29%',
						money:'',
						showMoney:'',
						selected:false,
						max:'29'
					}
				],
				
				showSuccess:false,
				
				travelLocationList:[],
				
				buttonInfo:{
					is_personal_profile:true,//个人资料
					is_pay:true,//收款方式
					is_video_tool:true,//视讯工具
					is_schedule:true,//日程
					is_class_manage:true,//课堂管理
					is_teaching_portfolio:true,//教学档案
					is_personal_photo:true,//个人照片
					is_work_experience:true,//工作经验
					is_self_introduction:true,//个人介绍
					is_introduction_film:true,//简介影片
					is_teaching_achievements:true,//教学成果
				},
				button_unfinished:0,//资料未完成个数
				
				chackRadio1:false,//教学成果隐私协议
				chackRadio2:false,//簡介影片
				data_completed:localStorage.getItem('data_completed'),
			}
		},
		watch:{
			data_completed_info(){
				this.button_unfinished = this.countFalseValues(this.buttonInfo)
			}
			
		},
		async created() {
			this.activeKey = this.defaultActiveKey
			this.buttonInfo = this.data_completed_info
			this.button_unfinished = this.countFalseValues(this.buttonInfo)
			// console.log("---this.buttonInfo",this.buttonInfo);
			console.log("data_completed",this.data_completed);
			let arr = await this.informationIntegration(['language', 'languageLevel', 'professorLevel',
				'specialEducationalExperience', 'educationBackground','travelLocation'
			])
			this.languageList = arr.list.language.list
			this.languageLevelList = arr.list.languageLevel.list
			this.travelLocationList = arr.list.travelLocation.list
			this.professorLevelList = arr.list.professorLevel.list.map(item=>{
				item.value = item.id
				item.label = item.name
				return item
			})
			this.professorLevelList.unshift({
				value:" ",
				label:this.$t('common.select')
			})
			this.specialEducationalExperienceL = arr.list.specialEducationalExperience.list.map(item=>{
				item.value = item.id
				item.label = item.name
				return item
			})
			this.specialEducationalExperienceL.unshift({
				value:" ",
				label:this.$t('common.select')
			})
			this.educationBackgroundL = arr.list.educationBackground.list
			if(this.userInfo.teacher_id){
				this.getTeacherInfo()
			}
			this.getClassifyList(1)
		},
		methods:{
			addWE(){
				this.form.work_experience.push({
					yearRange:['',''],
					schoolName:'',
					diplomaName:'',
					photo:'',
					is_edit:true
				})
			},
			countFalseValues(obj) {
			    let falseCount = 0; // 初始化计数器
			
			    // 遍历对象的每个属性
			    for (let key in obj) {
			        if (obj.hasOwnProperty(key)) { // 确保属性是对象自身的属性
			            if (obj[key] === false) { // 检查值是否为 false
			                falseCount++; // 如果是 false，计数器加一
			            }
			        }
			    }
			
			    return falseCount; // 返回 false 的数量
			},
			toComplete(num){
				this.$emit('changeIndex',num)
			},
			setVideo(){
				this.form.video_files.push(this.videoPath)
				this.videoPath = ''
			},
			delVideo(index){
				this.form.video_files.splice(index,1)
			},
			
			onEditorChange({
				quill,
				html,
				text
			}) {
				console.log('editor change!', quill, html, text)
				this.content = html
				this.form.self_introduction_content = html
			},
			
			// 课程分类
			async getClassifyList(teacherCourse){
				await this.$http.api('course/classifyList',{
					includeCourse:1,
					teacherCourse:teacherCourse?this.form.id:''
				}).then(res=>{
					this.classifyList = res.list
					if(teacherCourse&&res.list.length!=0){
						this.formTeacherC=res.list
						this.formTeacherTypeId = res.list[0].id
						this.formTeacherItem = res.list[0].course
					}
				})
				
			},
			changeLanguage() {
				
			},
			changeLevel(){
				let language_name='',language_level_name = ''
				this.languageList.forEach((item,index)=>{
					if(item.id==this.language_id){
						language_name = item.name
					}
				})
				
				this.languageLevelList.forEach((item,index)=>{
					if(item.id==this.language_level_id){
						language_level_name = item.name
					}
				})
				this.form.teacher_language.push({
					language_level_name,
					language_name,
					language_id:this.language_id,
					language_level_id:this.language_level_id
				})
			},
			teacherUpdate(num) {
				if(num==1&& !this.chackRadio1){
					this.$message.error('請閲讀并同意以上内容')
					return
				}
				if(num==2&& !this.chackRadio2){
					this.$message.error('請閲讀并同意上傳影片要求')
					return
				}
				this.$http.api('teacher/teacher/update',this.form ).then(res => {
					this.$message.success('提交成功',1,()=>{
						this.getTeacherInfo()
						this.$emit("update")
					})
					
				})
			},
			getTeacherInfo(){
				this.$http.api('teacher/teacher/info').then(res=>{
					res.info.professor_level_id = res.info.professor_level_id?this.changeSToN(res.info.professor_level_id):''
					res.info.course_classify_id = res.info.course_classify_id?this.changeSToN(res.info.course_classify_id):''
					res.info.special_educational_experience_id = res.info.special_educational_experience_id?this.changeSToN(res.info.special_educational_experience_id):''
					
					this.form = res.info
					this.content = this.form.self_introduction_content
					!this.form.introduce_images?this.form.introduce_images=[]:''
					!this.form.video_files?this.form.video_files=[]:''
					!this.form.educational_qualifications_information||this.form.educational_qualifications_information[0].yearRange==undefined?this.form.educational_qualifications_information=[
						{
							yearRange:['',''],
							schoolName:'',
							diplomaName:'',
							photo:''
						}
					]:''
					
					!this.form.professional_teacher_qualification?this.form.professional_teacher_qualification = {
						registeredTeacher:0,
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					}:''
					
					!this.form.other_professional_qualifications?this.form.other_professional_qualifications={
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					}:''
					!this.form.public_examination_results?this.form.public_examination_results=[]:''
					!this.form.work_experience||this.form.work_experience[0].yearRange==undefined?this.form.work_experience=[
						{
							yearRange:['',''],
							schoolName:'',
							diplomaName:'',
							photo:''
						}
					]:''
					this.form.teacher_language.forEach((item,index)=>{
						this.languageList.forEach((t,i)=>{
							if(item.language_id==t.id){
								item.language_name = t.name
							}
						})
						this.languageLevelList.forEach((t,i)=>{
							if(item.language_level_id==t.id){
								item.language_level_name = t.name
							}
						})
					})
				})
			},
		}
	}
</script>

<style>
	.teachingArchives-photo{
		width: 60px;
		margin: 0 10px;
		height: 60px;
	}
</style>